<template>
  <message-dialog
    v-model="dialogOpen"
    :title="'Subscribe to ' + siteName"
  >
    <q-item-label v-if="hitLimit">
      You have reached your {{ modelName || 'free' }} trial limit.
    </q-item-label>
    <q-item-label v-else>
      You have tried accessing a subscription-only feature.
    </q-item-label>
    <q-item-label v-if="!$q.platform.is.nativeMobile">
      <template v-if="!!modelName">
        To create more {{ modelName }}s and access other subscription-only features, please subscribe to {{ siteName }}.
      </template>
      <template v-else>
        To access this and other subscription-only features, please subscribe to {{ siteName }}.
      </template>
    </q-item-label>

    <template #actions>
      <q-btn
        flat
        label="Close"
        @click="onCancelClick"
      />
      <q-btn
        v-if="!$q.platform.is.nativeMobile && can(permissions.canManageBilling)"
        flat
        autofocus
        icon-right="mdi-arrow-right"
        label="Subscribe"
        color="blue"
        @click="goTo('settings/subscription')"
      />
    </template>
  </message-dialog>
</template>

<script>
// This component is used for message dialogs called dynamically
// Refer to https://quasar.dev/quasar-plugins/dialog#Invoking-custom-component
export default {
  props: {
    hitLimit: {
      type: Boolean,
      default: false
    },
    modelName: {
      type: String,
      default: null
    }
  },
  emits: [
    // REQUIRED
    'ok', 'hide'
  ],
  data () {
    return {
      dialogOpen: false
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.dialogOpen = true
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.dialogOpen = false
    },
    onCancelClick () {
      // we just need to hide dialog
      this.hide()
    }
  }
}
</script>
